import { render, staticRenderFns } from "./scFilters.vue?vue&type=template&id=faa1245a&scoped=true&"
import script from "./scFilters.vue?vue&type=script&lang=js&"
export * from "./scFilters.vue?vue&type=script&lang=js&"
import style0 from "./scFilters.vue?vue&type=style&index=0&id=faa1245a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa1245a",
  null
  
)

export default component.exports